export const DEFAULT_RATIOS = [
  1/1,
  3/2,
  4/5,
  5/4,
  2/3,
]

export const VIDEO_RATIO = 16/9